module.exports = __webpack_public_path__ + "img/slide1.4ad681f4.png";